import { POSTS_FEATURE_KEY } from '@features/blog/posts-feature-key';
import { PostsState } from '@features/blog/posts-state';
import {
  FEATURE_KEY as SECTIONS_FEATURE_KEY,
  initialState as initialSectionsState,
  SectionsState,
} from '@features/content-packages/sections/sections-state';
import { ExternalUserRegistrationState } from '@features/external-user';
import { FEATURE_KEY as EXTRAORDINARY_INFORMATIONS_FEATURE_KEY } from '@features/extraordinary-information/feature-key';
import { INITIAL_EXTRAORDINARY_INFORMATIONS_STATE } from '@features/extraordinary-information/initial-extraordinary-informations-state';
import { Type } from 'class-transformer';
import { FEATURE_KEY as INTRODUCTION_FEATURE_KEY } from '@features/introduction/feature-key';
import { initialState as initialIntroductionState } from '@features/introduction/initial-state';
import { IntroductionState } from '@features/introduction/introduction-state';
import { AssetSummaryState } from './features/asset-summary/asset-summary-state';
import { initialState as initialAssetSummaryState } from './features/asset-summary/initial-state';
import { UserState } from './features/auth/user-state';
import { INITIAL_POSTS_STATE } from './features/blog/initial-posts-state';
import {
  ClientStateState,
  initialState as initialClientStateState,
} from './features/client-state/client-state-state';
import { FEATURE_KEY as CLIENT_STATE_FEATURE_KEY } from './features/client-state/feature-key';
import { CollectionState } from './features/collections/collection-state.interface';
import {
  ContentPackagesState,
  FEATURE_KEY as CONTENT_PACKAGES_FEATURE_KEY,
  initialState as initialContentPackagesState,
} from './features/content-packages/content-packages-state';
import { FilterState, initialState as initialFilterState } from './features/filters/filter-state';
import { initialState as initialOrderState, OrderState } from './features/orders/order-state';
import { initialState as initialSearchState, SearchState } from './features/search/search-state';
import { FEATURE_KEY as COLLECTIONS_FEATURE_KEY } from './features/collections/feature-key';

export const initialState: AppState = Object.freeze({
  search: initialSearchState,
  filters: initialFilterState,
  [COLLECTIONS_FEATURE_KEY]: new CollectionState(),
  orders: initialOrderState,
  user: new UserState(),
  externalUserRegistrations: new ExternalUserRegistrationState(),
  assetSummary: initialAssetSummaryState,
  router: {},
  [POSTS_FEATURE_KEY]: INITIAL_POSTS_STATE,
  [CLIENT_STATE_FEATURE_KEY]: initialClientStateState,
  [CONTENT_PACKAGES_FEATURE_KEY]: initialContentPackagesState,
  [SECTIONS_FEATURE_KEY]: initialSectionsState,
  [INTRODUCTION_FEATURE_KEY]: initialIntroductionState,
  [EXTRAORDINARY_INFORMATIONS_FEATURE_KEY]: INITIAL_EXTRAORDINARY_INFORMATIONS_STATE,
});

export class AppState {
  @Type(() => SearchState)
  search: SearchState;

  @Type(() => FilterState)
  filters: FilterState;

  @Type(() => CollectionState)
  [COLLECTIONS_FEATURE_KEY]: CollectionState;

  @Type(() => OrderState)
  orders: OrderState;

  @Type(() => UserState)
  user: UserState;

  @Type(() => ExternalUserRegistrationState)
  externalUserRegistrations: ExternalUserRegistrationState;

  @Type(() => ContentPackagesState)
  [CONTENT_PACKAGES_FEATURE_KEY]: ContentPackagesState;

  @Type(() => SectionsState)
  [SECTIONS_FEATURE_KEY]: SectionsState;

  @Type(() => ClientStateState)
  [CLIENT_STATE_FEATURE_KEY]: ClientStateState;

  assetSummary: AssetSummaryState;

  @Type(() => PostsState)
  [POSTS_FEATURE_KEY]: PostsState;

  [INTRODUCTION_FEATURE_KEY]: IntroductionState;

  router: Record<string, unknown>;
}
